"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = void 0;
var Preact = __importStar(require("preact"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var Button = __importStar(require("./A_Button"));
var Divider_1 = __importDefault(require("@mui/material/Divider"));
var icons_1 = require("./icons");
var Component = function (props) {
    return (Preact.h(Box_1.default, { sx: { height: '36px', display: 'flex' } },
        Preact.h(Button.Component, { variant: "outlined", color: "secondary", size: "medium", startIcon: Preact.h(icons_1.RefreshIcon, null), sx: { marginRight: '8px' }, onClick: props.refreshAction }, props.refreshButtonCopy),
        Preact.h(Divider_1.default, { orientation: "vertical", flexItem: true, sx: { marginRight: '8px' } }),
        Preact.h(Button.Component, { variant: "outlined", color: "secondary", size: "medium", startIcon: props.secondaryIcon, sx: { marginRight: '8px' } }, props.secondaryText),
        Preact.h(Button.Component, { variant: "contained", color: "primary", size: "medium", startIcon: props.primaryIcon, onClick: props.primaryAction }, props.primaryText)));
};
exports.Component = Component;
